export class Delegations{
  id: string;
  data: Delegation[];
}

export class Delegation{
  delegataire: string;
  creancier: string;
  forfaitTTC: number;
}

export class DelegationOverride{
  constructor(_delegataire?: string, _forfaitTTC?: number) {
    this.delegataire = _delegataire;
    this.forfaitTTC = _forfaitTTC;
    this.evaluaId = 0;
  }

  delegataire: string;
  forfaitTTC?: number;
  evaluaId?: number;
}
